/* eslint-disable react/jsx-pascal-case */
import React from 'react'
import { Button } from 'reactstrap'
import get from 'lodash/get'
import styled from 'styled-components'

import { Button as _Button } from '../../buttons'

export const newProjectButton = (saveProject, hideModal) => {
  return (
    <div>
      <CustomButton color='success' onClick={ () => saveProject() }>Save Project</CustomButton>
      <CustomButton onClick={ () => hideModal() }>Cancel</CustomButton>
    </div>
  )
}
export const buttonClose = (hideForm, hideConfirm) => {
  return (
    <div>
      <CustomButton color='success' onClick={ () => hideForm() }>Yes</CustomButton>
      <CustomButton color='danger' onClick={ () => hideConfirm() }>No</CustomButton>
    </div>
  )
}
export const buttonSuccess = (type, hideConfirm) => {
  return <Button color="success" onClick={ () => hideConfirm(type) }>OK</Button>
}
export const addButton = (type, addOrEditCost, hideModal, disabled = false) => {
  return (
    <div>
      <CustomButton color='success' disabled={ disabled } onClick={ () => addOrEditCost(type) }>Add</CustomButton>
      <CustomButton onClick={ () => hideModal(type) }>Cancel</CustomButton>
    </div>
  )
}
export const applyButton = (type, addOrEditCost, hideModal) => {
  return (
    <div>
      <CustomButton color='success' onClick={ () => addOrEditCost(type) }>Apply</CustomButton>
      <CustomButton onClick={ () => hideModal(type) }>Cancel</CustomButton>
    </div>
  )
}
export const saveButton = (saveSnapshot, hideModal) => {
  return (
    <div>
      <CustomButton color='success' onClick={ () => saveSnapshot() }>Save</CustomButton>
      <CustomButton onClick={ () => hideModal() }>Cancel</CustomButton>
    </div>
  )
}
export const submitButton = (type, submitProject, approveOrRejectProject, hideModal) => {
  let text = 'Submit'
  if (type === 'approveProject') text = 'Approve'
  else if (type === 'rejectProject') text = 'Reject'
  return (
    <div>
      <CustomButton
        color={ type === 'rejectProject' ? 'danger' : 'success' }
        onClick={ type === 'submitProject' ? () => submitProject() : () => approveOrRejectProject(type) }
      >
        { text }
      </CustomButton>
      <CustomButton onClick={ () => hideModal(type) }>Cancel</CustomButton>
    </div>
  )
}
export const confirmSaveButton = (type, addOrEditCost, hideConfirm) => {
  let confirmType = ''
  if (type === 'confirmEditResource') confirmType = 'editResource'
  else if (type === 'confirmEditVendor') confirmType = 'editVendor'
  else if (type === 'confirmEditOtherCost') confirmType = 'editOtherCost'
  else if (type === 'confirmEditLicense') confirmType = 'editLicense'
  else if (type === 'confirmEditHardware') confirmType = 'editHardware'
  else if (type === 'confirmEditChangeRequest') confirmType = 'editChangeRequest'
  else if (type === 'confirmEditAttachment') confirmType = 'editAttachment'
  else if (type === 'confirmChangeProjectStatus') confirmType = 'confirmChangeProjectStatus'
  return (
    <div>
      <CustomButton color='success' onClick={ () => addOrEditCost(confirmType) }>Save</CustomButton>
      <CustomButton onClick={ () => hideConfirm(confirmType) }>Cancel</CustomButton>
    </div>
  )
}
export const buttonOK = (type, hideConfirm, props) => {
  return (
    // <Button
    //   color="success"
    //   onClick={ () => {
    //     hideConfirm(type)
    //     if (type === 'approveSuccess') get(props, 'history').replace('/inbox')
    //   }
    //   }
    // >OK</Button>
    <_Button
      theme='#28a745'
      // width='40px'
      // height='26px'
      width='50px'
      height='38px'
      onClick={ () => {
        hideConfirm(type)
        if (type === 'approveSuccess') get(props, 'history').replace('/inbox')
      } }
    >
    OK
    </_Button>
  )
}
export const buttonTryAgain = (type, hideConfirm) => {
  return <Button color="warning" onClick={ () => hideConfirm(type) }>Try Again</Button>
}
export const buttonDiscard = (tab, hideConfirm, handleDiscard) => {
  return (
    <ButtonGroup>
      {/* <CustomButton color="" onClick={ () => hideConfirm('confirmDiscard') }>Cancel</CustomButton> */}
      {/* <CustomButton color="danger" onClick={ () => handleDiscard(tab) }>Discard</CustomButton> */}
      <_Button
        theme='#D44B49'
        width='70px'
        // height='26px'
        height='38px'
        onClick={ () => handleDiscard(tab) }
      >
        Discard
      </_Button>
      <_Button
        theme='#6c757d'
        width='70px'
        // height='26px'
        height='38px'
        onClick={ () => hideConfirm('confirmDiscard') }
      >
        Cancel
      </_Button>
    </ButtonGroup>
  )
}

const CustomButton = styled(Button)`
  margin-right: 10px ;
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
`

const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;

    div:nth-child(1) {
      margin-right: 12px;
    }
`



// WEBPACK FOOTER //
// ./src/components/project-information/helper/button.js